import styled from "styled-components";
import { CookiePolicyBackground } from "./CookiePolicyBackground";
import { CookiePolicyContents } from "./CookiePolicyContents";
import { MainFooter } from "../../Footer/MainFooter";

export function ComponentCookiePolicy() {
	return (
		<HomepageContainer>
			<CookiePolicyBackground />
			<BodyContainer>
				<CookiePolicyContents />
			</BodyContainer>
			<footer style={{ width: "100%" }}>
				<MainFooter />
			</footer>
		</HomepageContainer>
	);
}

const HomepageContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
`;
const BodyContainer = styled.div`
	max-width: 1442px;
	padding: clamp(16px, 4vw, 50px) clamp(16px, 4vw, 136px);
	width: 100%;
`;
